import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface CustomToastProps {
  heading?: string;
  message?: string;
}

const CustomToast: React.FC<CustomToastProps> = ({ heading, message }) => {
  const MAX_MESSAGE_LENGTH = 200;
  const truncatedMessage =
    message && message.length > MAX_MESSAGE_LENGTH
      ? message.substring(0, MAX_MESSAGE_LENGTH) + '…'
      : message;

  return (
    <>
      {heading && message ? (
        <div>
          <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>{heading}</div>
          <div title={message}>{truncatedMessage}</div>
        </div>
      ) : (
        <div>
          <ToastContainer style={{ width: '450px' }} />
        </div>
      )}
    </>
  );
};

export default CustomToast;